// What the office is told about a customer email that rode along with a
// shipping action. jobq-api always logs the attempt (so_email_history) and
// returns an id for it, so an id alone never means the customer got anything:
// the API adds `email_error` / `combined_email_error` when SES refused the
// send or a non-prod deploy held it back (2026-09-18).

// Finalize SO shipment / pickup: the dialog's summary bit for the email.
export function finalizeEmailNote(responseBody, notify) {
  if (responseBody.email_sent) {
    const scoped = responseBody.email_scoped && Array.isArray(responseBody.email_pallets)
      ? ` covering the ${responseBody.email_pallets.length} pallet(s) not emailed before`
      : '';
    return `email sent to ${responseBody.recipient_count} recipient(s)${scoped}`;
  }
  if (responseBody.email_error) {
    // The finalize itself went through; the customer email did not.
    return `⚠ customer email NOT sent: ${responseBody.email_error} — see Email History`;
  }
  if (responseBody.email_skipped_reason) {
    // Say when and to whom, so "no email needed" is not read as "no email
    // was sent" (SO-1141 / SO-1138, 2026-10-26).
    return responseBody.notified_summary
      ? `no new email needed — the customer was already emailed: ${responseBody.notified_summary}`
      : 'no email needed — the customer was already notified for every pallet';
  }
  return notify ? 'no recipients on file' : 'email skipped';
}

// Ship all / Stage all: the bit for the one combined customer email, or null
// when no email was attempted. `what` names the attachment ("manifest",
// "pickup manifest").
export function batchEmailNote(body, what) {
  if (body.combined_email_error) {
    return `⚠ customer email NOT sent: ${body.combined_email_error} — see Email History`;
  }
  if (body.combined_email_id) return `customer emailed the ${what} for this batch`;
  return null;
}

// POD packet: { ok, message } — ok=false is shown as an error, not "Sent".
export function podSendNote(r) {
  if (r.email_error) return { ok: false, message: `Not sent to ${r.to_email}: ${r.email_error}` };
  const cc = r.cc_emails && r.cc_emails.length ? ` (cc ${r.cc_emails.join(', ')})` : '';
  return { ok: true, message: `Sent "${r.subject}" to ${r.to_email}${cc}.` };
}
